import Auth from '../auth/abstract-auth';
import { ORI_API_KEY } from '../constants';

export const CONSOLE_ERROR_MSG = 'It should be impossible to reach this point. gRPC makes a guarantee that the response will have either "error" or the results field.';

export const requestMetadata = async (auth: Auth, oriApiKey?: undefined | string) => {
  const token = await auth.getIdToken();
  const apiKey = oriApiKey || ORI_API_KEY || '';
  return {
    'Authorization': `Bearer ${token}`,
    'x-api-key': apiKey
  };
}
